import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ClientPickerComponent } from './smr-client-picker.component';
import { SalonMonsterLoadMaskModule } from '../smr-load-mask/smr-load-mask.module';
import { TapRetryComponentModule } from '../tap-retry/tap-retry.module';
import { ClientItemComponentModule } from '../client-item/client-item.module';
import { CircleTextAvatarComponentModule } from '../shared/circle-text-avatar/circle-text-avatar.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    CircleTextAvatarComponentModule,
    ClientItemComponentModule,
    SalonMonsterLoadMaskModule,
    TapRetryComponentModule,
  ],
  declarations: [ClientPickerComponent],
  exports: [ClientPickerComponent],
})
export class ClientPickerModule {}
